import { useMemo } from "react";
import { Field } from "react-final-form";

import TextInput from "../../inputs/TextInput";
import RffInputWrapper from "../shared/RffInputWrapper";

import { formatPhone } from "../../../_src_shared/utils/functions/formatPhone";
import { VALIDATOR_REQUIRE } from "../../../utils/finalForm/validators/VALIDATOR_REQUIRE";
import { TextField } from "@mui/material";

const RffPhoneField = ({
  name,
  label,
  required = false,
  suppressGrid,
  disabled,
  size,
  row = false,
  inlineLabel = false,
  placeholder = "Enter valid phone number",
}) => {
  const validate = useMemo(
    () => (required ? VALIDATOR_REQUIRE : undefined),
    [required],
  );

  const parsePhone = (value) => {
    // Always keep the raw digits in form state
    return value ? value.replace(/[^\d]/g, "") : "";
  };

  return (
    <RffInputWrapper
      label={inlineLabel ? null : label}
      suppressGrid={suppressGrid}
      size={size}
      row={row}
      required={required}
    >
      <Field
        name={name}
        parse={parsePhone}
        format={formatPhone}
        // formatOnBlur
        validate={validate}
        render={({ input, meta }) => {
          if (inlineLabel) {
            return (
              <TextField
                {...input}
                // onBlur={onBlur}
                disabled={disabled}
                label={label}
                placeholder={placeholder}
                error={meta.touched && !!meta.error}
                helperText={meta.touched && meta.error}
              />
            );
          }
          return (
            <TextInput
              {...input}
              // onBlur={onBlur}
              disabled={disabled}
              placeholder={placeholder}
              error={meta.touched && !!meta.error}
              helperText={meta.touched && meta.error}
            />
          );
        }}
      />
    </RffInputWrapper>
  );
};

export default RffPhoneField;
